export default "__VITE_ASSET__LVhpKKDb__"